export const clipTextWithEllipses = (text, maxLength) => {
  if (text) {
    // If the text length is less than or equal to maxLength, return the text as is
    if (text.length <= maxLength) {
      return text;
    }
    // Clip the text to the maximum length and add ellipses
    return text.slice(0, maxLength) + '...';
  }
  return '';
};
